<template>
  <div class="row wrapper border-bottom white-bg page-heading">
    <div class="col-lg-10">
      <h2>Maszyny</h2>
      <ol class="breadcrumb">
        <li>
          <router-link to="/">Home</router-link>
        </li>
        <li class="active">
          <strong>Maszyny</strong>
        </li>
      </ol>
    </div>
  </div>

  <div class="wrapper wrapper-content animated fadeInRight">
    <div class="row">
      <div class="col-lg-12">
        <div class="ibox float-e-margins">
          <div class="ibox-title">
            <h5>Maszyny</h5>
          </div>
          <div class="ibox-content">
            <router-link v-if="canAddMachine" to="/machines/create">
              <button class="btn btn-sm btn-primary">Dodaj</button>
            </router-link>
            <div class="row">
              <div class="col-sm-12 m-b-xs">
                <div class="form-group">
                  <label class="control-label col-sm-2">
                    Wpisz liczbę wierszy:
                  </label>
                  <div class="col-sm-2">
                    <input
                      class="form-control inputClass"
                      type="text"
                      v-model="rowsPerPage"
                      @change="setRowsPerPage"
                      @click="isSearch = false"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-12 m-b-xs" v-if="items">
                <button @click="resetFilters" class="btn btn-primary btn-xs">
                  <i class="fa fa-refresh"></i>
                </button>
                <div class="pagination" v-if="itemsAll">
                  <span class="items-all">
                    Ilość rekordów: <b>{{ itemsAll }}</b>
                  </span>
                  <span>
                    Ilość na stronę:
                    <select v-model="serverOptions.rowsPerPage">
                      <option value="25">25</option>
                      <option value="50">50</option>
                      <option value="100">100</option>
                    </select>
                  </span>
                  <span>
                    <input type="number" v-model="serverOptions.page" /> -
                    {{ Math.ceil(itemsAll / serverOptions.rowsPerPage) }}
                  </span>
                  <button @click="selectPage(1)" class="btn btn-primary ml-25">
                    Pierwsza
                  </button>
                  <button
                    @click="serverOptions.page = serverOptions.page - 1"
                    :disabled="serverOptions.page === 1"
                    class="prev nl"
                  ></button>
                  <button
                    @click="serverOptions.page = serverOptions.page + 1"
                    :disabled="
                      serverOptions.page ===
                      Math.ceil(itemsAll / serverOptions.rowsPerPage)
                    "
                    class="next"
                  ></button>
                  <button
                    @click="
                      selectPage(
                        Math.ceil(itemsAll / serverOptions.rowsPerPage)
                      )
                    "
                    class="btn btn-primary"
                  >
                    Ostatnia
                  </button>
                </div>
                <EasyDataTable
                  v-model:server-options="serverOptions"
                  :server-items-length="itemsAll"
                  :headers="headers"
                  :items="items"
                  :clickRowToExpand="false"
                  :loading="loading"
                  alternating
                  multi-sort
                  border-cell
                  @update-sort="updateSort"
                  class="table-search"
                >
                  <template #header="header">
                    <span v-if="header.text">{{ header.text }}</span>
                    <input
                      class="table-search"
                      type="text"
                      v-if="header.search"
                      v-model="searchValue[header.value]"
                      @keyup="search"
                      @click="isSearch = true"
                    />
                  </template>
                  <template #item-actions="item">
                    <router-link
                      v-if="canChangeMachine"
                      :to="'/machines/edit/' + item.pk"
                    >
                      <button class="btn btn-warning btn-xs">
                        <i class="fa fa-pencil" aria-hidden="true"></i>
                      </button>
                    </router-link>
                    <button
                      v-if="canDeleteMachine"
                      @click.stop="
                        showModal = item.pk;
                        deleteName = item.name;
                      "
                      class="btn btn-danger btn-xs"
                    >
                      <i class="fa fa-trash"></i>
                    </button>
                  </template>
                  <template #item-image="item">
                    <img width="50px" :src="item.image" />
                  </template>
                </EasyDataTable>
                <div class="pagination" v-if="itemsAll">
                  <span class="items-all">
                    Ilość rekordów: <b>{{ itemsAll }}</b>
                  </span>
                  <span>
                    Ilość na stronę:
                    <select v-model="serverOptions.rowsPerPage">
                      <option value="25">25</option>
                      <option value="50">50</option>
                      <option value="100">100</option>
                    </select>
                  </span>
                  <span>
                    <input type="number" v-model="serverOptions.page" /> -
                    {{ Math.ceil(itemsAll / serverOptions.rowsPerPage) }}
                  </span>
                  <button @click="selectPage(1)" class="btn btn-primary ml-25">
                    Pierwsza
                  </button>
                  <button
                    @click="serverOptions.page = serverOptions.page - 1"
                    :disabled="serverOptions.page === 1"
                    class="prev nl"
                  ></button>
                  <button
                    @click="serverOptions.page = serverOptions.page + 1"
                    :disabled="
                      serverOptions.page ===
                      Math.ceil(itemsAll / serverOptions.rowsPerPage)
                    "
                    class="next"
                  ></button>
                  <button
                    @click="
                      selectPage(
                        Math.ceil(itemsAll / serverOptions.rowsPerPage)
                      )
                    "
                    class="btn btn-primary"
                  >
                    Ostatnia
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <Modal
    v-if="showModal"
    :title="'Potwierdzenie usunięcia'"
    :content="'Czy na pewno chcesz usunąć <b>' + deleteName + '</b> ?'"
    @callbackOk="deleteMachines(showModal)"
    @callbackClose="showModal = false"
  />
</template>

<script>
import { computed, watch, ref, onMounted } from "vue";
import { useStore } from "vuex";
import { hasPermission } from "../../permissions";
import { machinePermissionsConst } from "../../constants/productionConstants";
import Modal from "../caffeprint/Modal.vue";

export default {
  name: "MachinesList",
  mixins: [],
  components: {
    Modal,
  },
  props: {},

  setup() {
    const store = useStore();
    const canAddMachine = computed(() =>
      hasPermission(machinePermissionsConst.add)
    );
    const canChangeMachine = computed(() =>
      hasPermission(machinePermissionsConst.update)
    );
    const canDeleteMachine = computed(() =>
      hasPermission(machinePermissionsConst.delete)
    );
    const deleteMachinesData = computed(
      () => store.getters.getDeleteMachinesData
    );
    const machineData = computed(() => store.getters.getMachineData);
    const updateMachinesData = computed(
      () => store.getters.getUpdateMachinesData
    );
    const machinesData = computed(() => store.getters.getMachinesData);
    const machineObj = ref({
      name: "",
      model: "",
      type: "",
      image: "",
    });
    let headers = [
      { text: "Nr", value: "pk" },
      { text: "Obraz", value: "image", sortable: true },
      {
        text: "Nazwa",
        value: "name",
        sortable: true,
        search: true,
      },
      {
        text: "Model",
        value: "model",
        sortable: true,
        search: true,
      },
      {
        text: "Typ",
        value: "type",
        sortable: true,
        search: true,
      },
      { text: "Data dodania", value: "date_added", sortable: true },
      { text: "Data modyfikacji", value: "date_modified", sortable: true },
      {
        text: "Zmodyfikowano przez",
        value: "last_modified_by",
        sortable: true,
      },
      {
        text: "Utworzono przez",
        value: "created_by",
        sortable: false,
      },
      { text: "Akcje", value: "actions" },
    ];

    let items = ref([]);
    let itemsAll = ref(0);
    const showModal = ref(false);
    const deleteName = ref("");
    const loading = ref(true);
    const searchValue = ref({});
    const isSearch = ref(false);
    const rowsPerPage = ref();
    const serverOptions = ref({
      page: 1,
      rowsPerPage: 25,
    });

    const getMachines = async () => {
      loading.value = true;
      let sort;
      if (serverOptions.value.sortType === "desc") {
        sort = "-" + serverOptions.value.sortBy;
      } else {
        sort = serverOptions.value.sortBy;
      }
      await store.dispatch("getMachines", {
        page: serverOptions.value.page,
        itemsPerPage: serverOptions.value.rowsPerPage,
        ordering: sort,
        search: searchValue.value,
      });
    };

    const deleteMachines = (pk) => {
      showModal.value = false;
      if (!canDeleteMachine.value) {
        return;
      }
      store.dispatch("deleteMachines", {
        pk: pk,
      });
    };
    const saveEdit = () => {
      if (!canChangeMachine.value) {
        return;
      }
      store.dispatch("updateMachines", machineObj.value);
    };

    const cancel = () => {
      document.querySelector(".expanding")?.click();
    };

    const editMachine = (item) => {
      cancel();
      store.dispatch("getMachine", { pk: item.pk });
    };

    const search = () => {
      isSearch.value = true;
      if (searchValue.value) {
        selectPage(1);
        setTimeout(() => {
          getMachines();
          isSearch.value = false;
        }, 1000);
      }
    };

    const resetFilters = () => {
      searchValue.value = {};
      serverOptions.value.sortBy = "";
      getMachines();
    };

    const updateSort = () => {
      search.value = true;
    };

    const selectPage = (page) => {
      serverOptions.value.page = page;
    };

    const setRowsPerPage = () => {
      serverOptions.value.rowsPerPage = rowsPerPage.value;
    };

    onMounted(() => {
      if (localStorage.getItem("machinesSearchValue") !== null) {
        searchValue.value = localStorage.getItem("machinesSearchValue");
        searchValue.value = JSON.parse(searchValue.value);
      }
      getMachines();
    });

    watch(
      () => searchValue.value,
      function () {
        localStorage.setItem(
          "machinesSearchValue",
          JSON.stringify(searchValue.value)
        );
        getMachines();
      },
      { deep: true }
    );

    watch(
      () => machinesData.value,
      function (newValue) {
        itemsAll.value = newValue.data.count;
        items.value = [];
        newValue.data.results?.forEach((element) => {
          items.value.push(element);
        });
        loading.value = false;
      }
    );

    watch(
      () => machineData.value,
      function (newValue) {
        machineObj.value = newValue.data;
      }
    );

    watch(
      () => deleteMachinesData.value,
      function (newValue) {
        if (newValue.status === 204) {
          store.dispatch("showToaster", {
            type: "success",
            content: "Maszyna została usunieta",
          });
        }
        getMachines();
      }
    );

    watch(
      () => updateMachinesData.value,
      function (newValue) {
        if (newValue.status === 200) {
          getMachines();
          store.dispatch("showToaster", {
            type: "success",
            content: "Dane zostały zaktualizowane",
          });
        }

        cancel();
      }
    );

    watch(
      () => serverOptions.value,
      function () {
        if (!isSearch.value) {
          getMachines();
          isSearch.value = false;
        }
      },
      { deep: true }
    );

    return {
      canAddMachine,
      canChangeMachine,
      canDeleteMachine,
      headers,
      items,
      itemsAll,
      loading,
      serverOptions,
      showModal,
      deleteMachines,
      deleteName,
      machineObj,
      cancel,
      editMachine,
      saveEdit,
      searchValue,
      isSearch,
      rowsPerPage,
      resetFilters,
      updateSort,
      search,
      selectPage,
      setRowsPerPage,
    };
  },
  computed: {},
};
</script>
